"use client";

import { sessionService } from '@/services/sessionService';

const SESSION_STORAGE_KEY = 'vtech_navigator_session_id';
const generateSecureId = () => {
  const array = new Uint8Array(16);
  crypto.getRandomValues(array);
  return Array.from(array, (b) => b.toString(16).padStart(2, "0")).join("");
};

// Legacy function for backward compatibility
export const getOrSetSessionId = (): string => {
  if (typeof window === 'undefined') {
    // Server-side: return a temporary ID
    return `temp_${Date.now()}_${generateSecureId()}`;
  }

  try {
    // Check if we have a backend session
    const sessionInfo = sessionService.getSessionInfo();
    if (sessionInfo.hasSession && sessionInfo.sessionId) {
      return sessionInfo.sessionId;
    }

    // Fallback to legacy session storage
    let sessionId = sessionStorage.getItem(SESSION_STORAGE_KEY);

   if (!sessionId) {
  sessionId = `legacy_${Date.now()}_${generateSecureId()}`;
  sessionStorage.setItem(SESSION_STORAGE_KEY, sessionId);
}


    return sessionId;
  } catch (error) {
    console.warn(
      "Session storage unavailable. Using temporary session ID.",
      error
    );
   return `temp_${Date.now()}_${generateSecureId()}`;
  }
};

// New function to create a proper backend session
export const createBackendSession = async (userId: string, userEmail: string, isAdmin: boolean = false): Promise<string> => {
  try {
    return await sessionService.createSession(userId, userEmail, isAdmin);
  } catch (error) {
    console.error('Failed to create backend session:', error);
    // Fallback to legacy method
    return getOrSetSessionId();
  }
};

// Function to validate current session
export const validateCurrentSession = async (): Promise<boolean> => {
  try {
    return await sessionService.isSessionValid();
  } catch (error) {
    console.error('Session validation failed:', error);
    return false;
  }
};

// Function to invalidate current session
export const invalidateCurrentSession = async (): Promise<boolean> => {
  try {
    return await sessionService.invalidateSession();
  } catch (error) {
    console.error('Session invalidation failed:', error);
    return false;
  }
};

// Export session service for direct use
export { sessionService };
